import { IngredientInitialState, IngredientResponse } from '@/src/types/apps/gygIngredient'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState: IngredientInitialState = {
  ingredients: [],
  loading: false,
  meta: {
    total: 0,
    pages: 0
  },
  error: null,
  success: null
}

export const getIngredients = createAsyncThunk<
  IngredientResponse,
  GygQueryOptions,
  { rejectValue: any; extra: { httpClient: any } }
>('gygIngredients/getIngredients', async (params, { rejectWithValue, extra }) => {
  try {
    const response = await extra.httpClient.get(`recipe-guide-ingredients`, { params })

    return response.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

const gygIngredientSlice = createSlice({
  name: 'gygIngredient',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getIngredients.pending, state => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getIngredients.fulfilled, (state, action) => {
      state.loading = false
      state.ingredients = action.payload.data
      state.meta = action.payload.meta
    })
    builder.addCase(getIngredients.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload || 'Failed to fetch ingredients'
    })
  }
})

export default gygIngredientSlice.reducer
